import { Component, OnInit } from '@angular/core';
import { LocationsService } from "../services/locations/locations.service";

@Component({
  selector: 'app-reservations',
  templateUrl: './reservations.component.html',
  styleUrls: ['./reservations.component.scss']
})
export class ReservationsComponent implements OnInit {
  public locations;

  constructor(private _locationsService: LocationsService) { }

  ngOnInit() {
    // (<any>window).googleMapsReady = this.onMapsReady.bind(this);
    // var script = document.createElement("script");
    // script.type = "text/javascript";
    // document.getElementsByTagName("head")[0].appendChild(script);
    // script.src =
    //   "https://maps.googleapis.com/maps/api/js?v=3&key=" +
    //   this.googleAPIKey +
    //   "&callback=googleMapsReady";

    this._locationsService.getLocations().subscribe(results => {
      this.locations = results["locations"];
      // console.log('locations', this.locations);
      // this.onMapsReady();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/reservations/reservations.component.ts